import {
  Button,
  Heading,
  Highlight,
  HStack,
  Image,
  PinInput,
  PinInputField,
  Spinner,
  Stack,
  Text,
  useBreakpointValue,
  useToast,
} from "@chakra-ui/react";
import { textLogo as logo } from "assets/images";
import { CopyRightText, MobileLinks } from "components/views";
import { useFormik } from "formik";
import { useTranslation } from "languages";
import { useLocation, useNavigate } from "react-router-dom";
import { AppLinks } from "tools/navigations";
import { useAppDispatch } from "tools/store";
import { ShowToast } from "utils/Helpers";
import * as Yup from "yup";
import { useResendOtpMutation, useVerifyLoginOtpMutation } from "../service";
import { setSession } from "../slice";
import { ResponseInterface } from "../types";

const VerifyOtp: React.FC = () => {
  // const theme = useTheme();
  // const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const otpLength = 4;
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [onVerification, { isLoading: otpLoad }] = useVerifyLoginOtpMutation();
  const [onResend, { isLoading: isResendLoad }] = useResendOtpMutation();
  const translation = useTranslation();
  const toast = useToast();

  const location = useLocation();
  const email = location.state; // Access the passed data

  // console.log("=-=-=-=-=-=item:", email);

  const validationSchema = Yup.object().shape({
    otp: Yup.string().required(),
  });

  const { values, handleSubmit, setFieldValue } = useFormik({
    initialValues: {
      otp: "",
    },
    validationSchema,
    onSubmit: async (values: any) => {
      // console.log("=-=-=-=", values)

      const response: ResponseInterface<any> = await onVerification({
        otp: values?.otp,
        email,
      });
      // console.log("=-=-=-=", response);
      if (!response.error && response.data) {
        navigate(AppLinks.DASHBOARD);
        dispatch(setSession(response.data));
        ShowToast(toast, translation["login_success"], "success");
      }
    },
  });

  const layoutDirection = useBreakpointValue({ base: "column", md: "row" });

  return (
    <Stack
      direction={["column", "row"]}
      w={"full"}
      h="100%"
      justifySelf={"flex-end"}
      bgGradient="linear(to-r, transparent, secondary.950 40%)"
      pr={[5, "180px"]}
      pl={[5, 0]}
      py={[5, 0]}
      overflow={"auto"}
    >
      {layoutDirection === "row" && <MobileLinks />}

      <Stack
        w={["100%", "35%"]}
        // h={"100%"}
        align={"center"}
        justify={"center"}
        pos={"relative"}
        // bgColor={"red"}
      >
        <Image src={logo} boxSize="150px" objectFit="cover" mb={"60px"} />

        <Heading size="xl" alignSelf={"flex-start"}>
          {translation["otp_verification"]}
        </Heading>

        <Text alignSelf={"flex-start"}>
          <Highlight
            query={email || "555"}
            styles={{ color: "primary.300", fontWeight: "bold" }}
          >
            {`${translation["please_enter_otp"]} ${email || "555"}`}
          </Highlight>
        </Text>

        <HStack justifyContent={"space-between"} w={"100%"} my={5}>
          <PinInput
            // size='lg'
            // onComplete={(otp) => setFieldValue("otp", otp)}
            onChange={(otp) => setFieldValue("otp", otp)}
          >
            {Array.from(Array(otpLength).keys()).map(() => (
              <PinInputField
                style={{ height: "70px", width: "70px" }}
                _hover={{
                  borderColor: "primary.300",
                }}
                _focus={{
                  borderColor: "primary.300",
                }}
              />
            ))}
          </PinInput>
        </HStack>

        <Button
          w={"100%"}
          onClick={() => {
            if (values.otp.length === 4) {
              handleSubmit();
            }
          }}
          isLoading={otpLoad}
        >
          {translation["confirm"]}
        </Button>

        <HStack alignSelf={"flex-start"} mt={1}>
          <Text>{translation["didnt_receive_otp"]}</Text>
          {isResendLoad ? (
            <Spinner size="sm" mx={5} />
          ) : (
            <Text
              as={"u"}
              color={"primary.300"}
              onClick={() => onResend(email)}
              _hover={{ cursor: "pointer" }}
            >
              {translation["resend"]}
            </Text>
          )}
        </HStack>

        {/* {steps === 0 && <HStack justify={'space-between'} w={"100%"} mt={2}>
          <Link
            alignSelf={'flex-start'}
            mt={1}
            href='http://qapp.thesoftwarestudios.com/initiate-password-reset'
            isExternal
          >
            <Text as={'u'} fontWeight={'medium'}>Forget Password</Text>
          </Link>
          <Text>
            Don’t have a account? {' '}
            <Link color='primary.300' href={AppLinks.REGISTER}>
              Register
            </Link>
          </Text>
        </HStack>} */}

        <CopyRightText />
      </Stack>
    </Stack>
  );
};

export default VerifyOtp;
